import React, { Component } from 'react';
import { colorStyles } from './colorStyles';
import T from 'i18n-react';
import Select from 'react-select';

class ProvinceDropDown extends Component {
    constructor(props) {
        super(props)

        this.provinceOptions = [
            T.translate('Common.Provinces.Option0'),
            T.translate('Common.Provinces.Option1'),
            T.translate('Common.Provinces.Option2'),
            T.translate('Common.Provinces.Option3'),
            T.translate('Common.Provinces.Option4'),
            T.translate('Common.Provinces.Option5'),
            T.translate('Common.Provinces.Option6'),
            T.translate('Common.Provinces.Option7'),
            T.translate('Common.Provinces.Option8'),
            T.translate('Common.Provinces.Option9'),
            T.translate('Common.Provinces.Option10'),
            T.translate('Common.Provinces.Option11'),
            T.translate('Common.Provinces.Option12'),
        ]

        this.provinceKeys = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']

        this.state = {
            selectedOption: this.props.value,
            name: this.props.name,
            missingRequiredField: this.props.missingRequiredField
        }
    }

    componentWillReceiveProps(newProps) {
        this.provinceOptions = [
            T.translate('Common.Provinces.Option0'),
            T.translate('Common.Provinces.Option1'),
            T.translate('Common.Provinces.Option2'),
            T.translate('Common.Provinces.Option3'),
            T.translate('Common.Provinces.Option4'),
            T.translate('Common.Provinces.Option5'),
            T.translate('Common.Provinces.Option6'),
            T.translate('Common.Provinces.Option7'),
            T.translate('Common.Provinces.Option8'),
            T.translate('Common.Provinces.Option9'),
            T.translate('Common.Provinces.Option10'),
            T.translate('Common.Provinces.Option11'),
            T.translate('Common.Provinces.Option12'),
        ]
        if (newProps.value !== this.state.selectedOption) {
            this.setState({ selectedOption: newProps.value })
        }
        if (this.state.missingRequiredField !== newProps.missingRequiredField) {
            this.setState({ missingRequiredField: newProps.missingRequiredField })
        }
    }

    handleProvinceChange(evData) {
        var state = {
            ...this.state,
            selectedOption: evData?.value
        }

        this.setState(state);
        if (this.props.onValueChanged) {
            var ev = { target: { name: this.props.name } }
            this.props.onValueChanged(ev, evData?.value)
        }
    }

    render() {
        var classNames = ['select_container_div']
        if (this.state.missingRequiredField) {
            classNames.push('validationError')
        }

        var options = []
        for (var i = 0; i < this.provinceOptions.length; ++i) {
            options.push({ value: this.provinceKeys[i], label: this.provinceOptions[i] })
        }

        var dropdownValue = this.state.selectedOption ? {
            label: options.find(a => a.value == this.props.value)?.label,
            value: this.state.selectedOption
        } : '';

        return (
            <div className={classNames.join(' ')}>
                <Select
                    inputId="prov-select"
                    ref={(ref) => { this.select = ref; }}
                    options={options}
                    simpleValue
                    isClearable={true}
                    error={this.state.missingRequiredField}
                    name="selected-prov"
                    disabled={false}
                    value={dropdownValue}
                    onChange={(ev) => this.handleProvinceChange(ev)}
                    searchable={true}
                    placeholder={T.translate('Common.Choose')}
                    menuShouldScrollIntoView={false}
                    matchPos='start'
                    openMenuOnFocus={true}
                    styles={colorStyles}
                    backspaceRemovesValue={true}
                />
            </div>
        )
    }
}

export default ProvinceDropDown;